import { render, staticRenderFns } from "./CardStudentInfo.vue?vue&type=template&id=b19a917e&scoped=true"
import script from "./CardStudentInfo.vue?vue&type=script&lang=js"
export * from "./CardStudentInfo.vue?vue&type=script&lang=js"
import style0 from "./CardStudentInfo.vue?vue&type=style&index=0&id=b19a917e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19a917e",
  null
  
)

export default component.exports